<template>
  <div class="header">
    <img class="logo" :src="logo" />
    <div class="menus">
      <div class="top_menu">

        <div class="top_menu_left" :style="{ color: socketConnect ? '#07B477' : '#FF5555' }">
          <span style="font-size: 12px;margin-right: 10px;">{{ $t("route.技术支持") }}：{{ DEFAULT_TEL }}</span>
          <span v-if="supportTodayDataQuery" style="font-size: 12px;margin-right: 10px;cursor: pointer;"
            @click="gotoV2">{{ $t("route.进入旧版") }}</span>
          <i :class="socketConnect ? 'icon-icon_top_wifi' : 'icon-icon_top_wifi1'
            " class="iconfont"></i>
          <span v-if="socketConnect">{{ $t("public.connected") }}</span>
          <span v-else>{{ $t("public.disconnected") }}</span>
        </div>
        <div class="top_menu_right">
          <span v-for="(item, index) in subMenus" :key="index" @click="gotoView(item)">{{ item.title }}</span>

          <el-dropdown @command="changeLang">
            <span class="el-dropdown-link">
              {{ languages[langIndex].title }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, index) in languages" :key="item.id" :command="index">{{ item.title
              }}</el-dropdown-item>

            </el-dropdown-menu>
          </el-dropdown>

          <!--增加app下载-->
          <el-dropdown trigger="hover" v-if="supportTodayDataQuery">
            <span class="el-dropdown-link">
              {{ $t("public.appDownload") }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="app-download-menu">
              <div class="app-download-container">
                <div class="app-download-item">
                  <img class="app-qrcode" :src="require('@/assets/images/kingwings_android.png')" alt="Android下载" />
                  <span class="app-platform">Android</span>
                </div>
                <div class="app-download-item">
                  <img class="app-qrcode" :src="require('@/assets/images/kingwings_ios.png')" alt="iOS下载" />
                  <span class="app-platform">iOS</span>
                </div>
              </div>
            </el-dropdown-menu>
          </el-dropdown>

          <span @click="logOut">{{ $t("public.quit") }}</span>
        </div>
      </div>
      <div class="main_menu">
        <el-menu router mode="horizontal" background-color="#00358C" text-color="#E8F0FF" active-text-color="#E8F0FF"
          :default-active="$route.path" @select="activeSelect">
          <el-submenu v-for="(item, index) in permission_routes" :index="item.path" :key="index">
            <template slot="title"><i class="iconfont" :class="item.meta.icon"></i>{{ item.meta.title }}</template>
            <el-menu-item :index="item.path + '/' + n.path" :key="i" v-for="(n, i) in item.children">{{ n.meta.title
            }}</el-menu-item>
          </el-submenu>
        </el-menu>
        <div style="
            position: absolute;
            top: 35px;

            z-index: 1000;
            width: 150px;
          ">
          <el-menu router v-if="false" background-color="#00358C" text-color="#E8F0FF" active-text-color="#E8F0FF"
            ref="moremenu" @select="handleSelect">
            <el-submenu index="/more">
              <template slot="title"><i class="iconfont icon-icon_top_mall"></i>更多</template>
              <el-submenu :index="item.path" :key="index" v-for="(item, index) in permission_routes"
                v-if="checkShowMenu(index, 0)">
                <template slot="title"><i class="iconfont" :class="item.meta.icon"></i>{{ item.meta.title }}</template>
                <el-menu-item :index="item.path + '/' + n.path" :key="i" v-for="(n, i) in item.children">{{ n.meta.title
                }}</el-menu-item>
              </el-submenu>
            </el-submenu>
          </el-menu>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { queryMenuInfo } from "@/http/vehicle";
import settings from "@/settings";
import MapLoader from "@/utils/map_loader"
export default {
  computed: {
    ...mapGetters(["permission_routes", "socketConnect"]),
    logo() {
      switch (this.$store.getters.locale) {
        case "en-us":
          return require("@/assets/images/logo_topbar_en.png");
        case "es-es":
          return require("@/assets/images/logo_topbar_es.png");

        case "zh-TW":
          return require("@/assets/images/logo_topbar_cht.png");
      }
      return require("@/assets/images/logo_topbar_chs.png");
    },
    DEFAULT_TEL() {
      return settings.DEFAULT_TEL;
    },
    supportTodayDataQuery() {
      return settings.supportTodayDataQuery;
    },
    langIndex() {
      return this.languages.findIndex((item) => item.language == this.$store.getters.locale);
    },
    subMenus() {
      return [
        // {
        //     title: "SIM卡充值",
        //     path: "/home"
        // }, {
        //     title: "服务点查询",
        //     path: "/"
        // }, {
        //     title: "APP下载",
        //     path: "/"
        // }, {
        //     title: "公众号",
        //     path: "/"
        // }, {
        //     title: "系统公告",
        //     path: "/"
        // }, {
        //     title: "信息反馈",
        //     path: "/"
        // }, {
        //     title: "帮助",
        //     path: "/"
        // },
        {
          title: this.$t("route.feedback"),
          path: "/setting/feedback",
        },
        {
          title: this.$t("changepsw.page_title"),
          path: "/setting/changepsw",
        },
      ]
    }
  },
  created() {
    window.addEventListener("resize", this.GetWindowInfo); //注册监听器
    this.GetWindowInfo();
  },
  destroyed() {
    window.removeEventListener("resize", this.GetWindowInfo);
  },
  data() {
    return {
      languages: [{
        id: "1",
        title: "中文(简体)",
        language: "zh-cn"
      }, {
        id: "2",
        title: "中文(繁體)",
        language: "zh-TW"
      },
      {
        id: "3",
        title: "English(US)",
        language: "en-us"
      }
        ,
      {
        id: "5",
        title: "Español(ES)",
        language: "es-es"
      }
      ],
      menuActive: "1",
      menus: [],
      width: 0,

    };
  },
  mounted() {

    new MapLoader().loadBaiduMap().then(() => {
      console.log('Baidu Map loaded successfully');
    });
    //后面还要改成和登录选择的相关配置
    if (this.$store.getters.operator.IsForeign == 1) {

      this.$store.commit("app/changeMapType", "google");
      //修改store中的mapKey 写在配置里面
      // this.$store.commit("app/changeMapKey", AppConfig.GOOGLE_MAP_KEY);

      new MapLoader().loadGoogleMap().then(() => {
        console.log('Google Map loaded successfully');
      });
    } else {

      this.$store.commit("app/changeMapType", "baidu");
      //修改store中的mapKey
      // this.$store.commit("app/changeMapKey", AppConfig.BAIDU_MAP_KEY);
    }

    // console.log("地图类型", this.$store.getters.mapType);

    //地图加载，根据不同的类型加载不同的地图
    // if (this.$store.getters.mapType === 'google') {

    // }

    if (this.$store.getters.mapType === 'amap') {
      new MapLoader().loadAMap().then(() => {
        console.log('AMap loaded successfully');
      });
    }
  },
  methods: {
    activeSelect(index, indexPath) {
      // console.log(index,indexPath);
      const route = this.$router.resolve(index);
      // console.log(route);
      const routeName = route.route.name;
      this.$api.addMenuLog({
        operatorID: this.$store.getters.operator.OperatorId,
        FuncName: routeName,
        operatorName: this.$store.getters.operator.OpeName,
        sysSource: 0, //0\用户，1\售后,\3后台
      })
        .then((res) => {
        })
        .catch((e) => {

        })
    },

    handleSelect(key, keyPath) {
      this.$nextTick(() => {
        this.$refs.moremenu.close(keyPath[1]);
        this.$refs.moremenu.close(keyPath[0]);
      });
    },
    checkShowMenu(index, type) {
      //最小宽度 700
      // if (this.width > 1400) {
      //     if (index < 7)
      //         return type == 1 ? true : false;
      //         else {
      //         return type == 0 ? true : false;
      //     }
      // }
      // else if (this.width > 1300) {
      //     if (index < 6)
      //         return type == 1 ? true : false;
      //         else {
      //         return type == 0 ? true : false;
      //     }
      // }
      // else
      if (this.width > 1420) {
        return type == 1 ? true : false;
      } else if (this.width > 1250) {
        if (index < 4) return type == 1 ? true : false;
        else {
          return type == 0 ? true : false;
        }
      } else if (this.width > 1100) {
        if (index < 3) return type == 1 ? true : false;
        else {
          return type == 0 ? true : false;
        }
      } else if (this.width >= 950) {
        if (index < 2) return type == 1 ? true : false;
        else {
          return type == 0 ? true : false;
        }
      } else if (this.width >= 800) {
        if (index < 1) return type == 1 ? true : false;
        else {
          return type == 0 ? true : false;
        }
      } else if (this.width >= 700) {
        return type == 0 ? true : false;
      }
    },
    GetWindowInfo() {
      this.width = document.body.clientWidth;
      // console.log(this.width);
    },
    gotoV2() {
      window.open("https://v2.kingwings.cn/");
    },
    gotoView(item) {
      if (item && item.path) {
        this.$router.push(item.path);
      }
    },
    async changeLang(index) {

      //切换当前语言为英文
      // console.log(this.$store.getters.locale);
      var currentLang = this.languages[index].language;
      var id = this.languages[index].id;

      var res = await queryMenuInfo({
        LanguageID: parseInt(id),
      })
      // console.log(res);
      this.$i18n.locale = currentLang;
      this.$store.commit("app/changeLocale", currentLang);
      //通知语言切换事件
      // this.$emit("changeLang", currentLang);
      this.$bus.$emit("changeLang", currentLang);


      var menus = res.data || [];


      this.$store.dispatch("user/resetMenus", menus);

      //刷新页面
      this.$router.go(0);


    },
    async logOut() {
      //退出登录
      this.$confirm(this.$t("confirm.logout"), this.$t("public.tips"), {
        confirmButtonText: this.$t("public.confirm"),
        cancelButtonText: this.$t("public.cancel"),
        type: "warning",
      })
        .then(() => {
          this.$api.logout().then(async (res) => {
            if (res && res.code == 200) {
              await this.$store.dispatch("user/logout");
              this.$router.push(`/login?redirect=${this.$route.fullPath}`);
            }
          });
        })
        .catch(() => { });
      return;
    },
  },
};
</script>

<style scoped>
.app-download-menu {
  padding: 15px;
  min-width: 260px;
  text-align: center;
}

.app-download-container {
  display: flex;
  justify-content: space-around;
}

.app-download-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.app-qrcode {
  width: 100px;
  height: 100px;
  margin-bottom: 10px;
  border: 1px solid #e0e0e0;
}

.app-platform {
  font-size: 14px;
  color: #606266;
}
</style>
<style lang="scss" scoped>
.header {
  display: flex;
  width: 100%;
  padding: 0 !important;
  height: 90px !important;
  background-image: url("~@/assets/images/image_top_background.png");
  background-size: cover;
  background-repeat: no-repeat;

  ::v-deep {
    .el-menu.el-menu--horizontal {
      border-top: solid 1px transparent;
      border-bottom: 0 !important;
    }

    .el-menu--horizontal>.el-submenu .el-submenu__title {
      border-bottom: solid 1px #00358c !important;
    }

    .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
      background-color: #0059ed !important;
    }

    .el-menu--horizontal>.el-submenu .el-submenu__title,
    .el-menu--horizontal>.el-menu-item {
      height: 54px !important;
      line-height: 54px !important;
    }
  }

  .logo {
    height: 46px;
    float: left;
    margin: 18px 0 0 30px;
  }

  .menus {
    flex: 1;
    display: flex;
    flex-direction: column;

    .top_menu {
      height: 34px;
      display: flex;
      align-items: center;
      float: right;
      flex-direction: row;

      span {
        font-size: 12px;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 14px;
      }

      .top_menu_left {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        i {
          font-size: 20px;

          margin-right: 8px;
          margin-bottom: 4px;
        }
      }

      .top_menu_right {
        display: flex;
        flex-direction: row;
        margin-right: 16px;
        margin-left: 16px;
        justify-content: space-evenly;

        span {
          cursor: pointer;
          margin-right: 16px;
        }
      }
    }
  }

  .el-dropdown {
    font-size: 12px !important;
  }

  .main_menu {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-right: 16px;

    .menu_item {
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0 15px;
      cursor: pointer;
    }

    .menu_item:hover {
      background: #0059ed;
    }

    i {
      color: #fff;
      font-size: 24px;
      margin-right: 8px;
    }
  }
}
</style>
